import * as React from "react";
import { useState } from "react";
import Button from "../core/Button";
import { addReviewComment } from "../../libs/commission_calculator";
import { toast } from "../../utils";
import * as Sentry from "@sentry/browser";

export function CommentBox({ commissionId, commissionPromise }) {
  const [text, setText] = useState("");
  const [submittingComment, setSubmittingComment] = useState(false);

  function submitComment(text) {
    setSubmittingComment(true);
    return addReviewComment(commissionId, text)
      .then(() => {
        setSubmittingComment(false);
        commissionPromise.reload();
      })
      .catch(e => {
        toast.error("Error adding comment");
        Sentry.captureException(e);
      });
  }

  return (
    <div style={{ width: "100%" }}>
      <div className="columns is-vcentered">
        <div className="column is-6">
          <textarea
            value={text}
            onChange={e => setText(e.target.value)}
            placeholder="Comment here"
            style={{ width: "100%" }}
          />
        </div>
        <div className="column">
          <Button
            onClick={() => {
              const submissionText = text;
              setText("");
              submitComment(submissionText)
                .then(() => {})
                .catch(() => setText(submissionText));
            }}
            loading={submittingComment}
          >
            Send
          </Button>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommentBox.tsx